import Banner from '@/assets/img/ai/banner.jpg'
import SubBanner from '@/assets/img/ai/sub-banner.jpg'
import ContentBanner from '@/assets/img/ai/content-banner.jpg'
import { IconName } from '@/components/icon'

export interface AiProps {
  banner: {
    title: string
    description: string
    image: string
  }
  subBanner: {
    title: string
    image: string
    benefits: {
      title: string
      list: {
        icon: IconName
        label: string
      }[]
    }
  }
  ContentBanner: {
    title: string
    image: string
    offers: {
      title: string
      list: {
        title: string
        description: string
      }[]
    }
  }
}

export const aiEn: AiProps = {
  banner: {
    title: 'EnPact AI technology Evidence-based End-to-end Solution',
    description:
      'Integrating advanced energy optimization technologies with cutting-edge decarbonization systems to provide comprehensive solutions for monitoring, analyzing, and optimizing energy use while significantly reducing carbon emissions.',
    image: Banner,
  },
  subBanner: {
    title:
      'Average 50% of the electricity costs for a hospital and food processing company are HVAC and refrigeration.',
    benefits: {
      title: 'Benefits Of Our Solution',
      list: [
        {
          icon: 'reduce',
          label: '20%+ Reduction in Energy Costs',
        },

        {
          icon: 'payback',
          label: 'Typical Payback in 12–24 Months',
        },
        {
          icon: 'day1',
          label: 'Day 1 Savings',
        },
        {
          icon: 'co2',
          label: 'Verified CO2 Reductions',
        },
        {
          icon: 'energyConsume',
          label: 'Monitor Energy Consumption in Real Time',
        },
      ],
    },
    image: SubBanner,
  },
  ContentBanner: {
    title: 'Provide professional carbon neutrality solutions',
    image: ContentBanner,
    offers: {
      title: 'What do we offer?',
      list: [
        {
          title: '30～40%',
          description: 'enPact refrigeration cuts supermarket and F+B cooling energy use',
        },
        {
          title: '5～10%',
          description: 'enPact Voltage cuts energy use',
        },
        {
          title: 'ARK',
          description: 'ARK monitors energy savings and carbon reductions.',
        },
        {
          title: '5～10%',
          description: 'HVAC Al cuts energy use',
        },
        {
          title: '12～20%',
          description: 'enPact chiller cuts AHU energy use',
        },
        {
          title: '20～40%',
          description: 'Enpact AC cuts energy use ',
        },
      ],
    },
  },
}

export const i18nAi = {
  en: aiEn,
  es: aiEn,
  cn: aiEn,
}
